module.exports = __webpack_public_path__ + "img/logo-pagbrasil.1dff731f.svg";